export default {
  warning:
    'Deze vestiging is niet aan een merk gekoppeld. Om ervoor te zorgen dat het systeem goed werkt, moet de vestiging bij een merk horen. Voeg deze vestiging toe aan een merk.',
  cta: 'Naar merken',
};
